"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGettersFromRecord = exports.getTypeFromString = exports.looseEquals = void 0;
const date_fns_1 = require("date-fns");
const looseEquals = (value, expect) => value.replaceAll(":", " ").localeCompare(expect, undefined, {
    sensitivity: "accent",
    ignorePunctuation: true
}) === 0;
exports.looseEquals = looseEquals;
const getTypeFromString = (value, type) => {
    if (type === "date") {
        let date;
        if (/^\d{1,2}\/\d{1,2}\/\d{4} at .*$/.test(value)) {
            date = date_fns_1.parse(value, "M/d/yyyy 'at' p 'MDT'", new Date());
        }
        else if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) {
            date = date_fns_1.parse(value, "M/d/yyyy", new Date());
        }
        else if (/^\d{1,2}\/\d{1,2}\/\d{2}$/.test(value)) {
            date = date_fns_1.parse(value, "M/d/yy", new Date());
        }
        else if (/^\d{1,2}-\d{1,2}-\d{2}$/.test(value)) {
            date = date_fns_1.parse(value, "M-d-yy", new Date());
        }
        else if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(value)) {
            date = date_fns_1.parse(value, "M-d-yyyy", new Date());
        }
        else {
            throw new Error("is not a supported date format");
        }
        date = date_fns_1.addHours(date, 12);
        return date;
    }
    if (type === "number") {
        const number = Number(value === null || value === void 0 ? void 0 : value.replaceAll(",", "").replaceAll("$", ""));
        if (Number.isNaN(number)) {
            throw new Error("is not a number");
        }
        return number;
    }
    if (type === "boolean") {
        const booleanValue = value === null || value === void 0 ? void 0 : value.toLowerCase();
        if (["true", "t", "yes", "y"].includes(booleanValue)) {
            return true;
        }
        return false;
    }
    return value;
};
exports.getTypeFromString = getTypeFromString;
const getValueFromRecord = (record, type) => (field, defaultValue) => {
    var _a;
    const key = Object.keys(record).find((value) => exports.looseEquals(value, field));
    if (!key) {
        throw new Error(`Cannot find field ${field}`);
    }
    const fieldValue = (_a = record[key]) === null || _a === void 0 ? void 0 : _a.trim();
    if (!fieldValue && defaultValue) {
        return defaultValue;
    }
    try {
        return exports.getTypeFromString(fieldValue, type);
    }
    catch (error) {
        throw new Error(`Value for ${field} ${fieldValue} ${error.message}`);
    }
};
const getGettersFromRecord = (record) => ({
    getStringValue: getValueFromRecord(record, "string"),
    getNumberValue: getValueFromRecord(record, "number"),
    getDateValue: getValueFromRecord(record, "date"),
    getBooleanValue: getValueFromRecord(record, "boolean")
});
exports.getGettersFromRecord = getGettersFromRecord;
//# sourceMappingURL=index.js.map